import { Link } from 'react-router-dom';
import { hotComics } from '@/mocks/home';

export default function HotComics() {
  return (
    <section id="hot-comics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            热门韩漫推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            精选最受欢迎的韩国漫画作品，每一部都拥有超高人气和口碑
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3" style={{ aspectRatio: '3/4' }}>
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">
                    TOP {index + 1}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1 text-white/90">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-xs" style={{ color: 'oklch(var(--accent-400))' }}></i>
                    </div>
                    <span className="text-xs font-medium">{comic.rating}</span>
                    <span className="text-xs text-white/50 ml-auto">{comic.views > 1000000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}阅</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-1">{comic.description}</p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/#categories"
            className="inline-flex items-center gap-1.5 px-6 py-2.5 text-sm font-medium rounded-full border border-primary-300 text-primary-600 whitespace-nowrap hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
          >
            查看全部热门
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}